module.exports = " <div class=\"errortips datang\" _v-6323bb72=\"\"> <h4 _v-6323bb72=\"\">数据加载失败</h4> <p _v-6323bb72=\"\">请检查您的手机是否联网,点击按钮重新加载</p> <a href=javascript:; :class=\"{'hover':activeClass}\" @click=clickEvent @touchstart=addActive @touchmove=addActive @touchend=removeActive _v-6323bb72=\"\">重新加载</a> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-6323bb72!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Error.vue
// module id = 155
// module chunks = 0